export const messages = {
  scheduling: {
    title: {
      id: 'admin/promotions.form.review.scheduling',
    },
    dateRange: {
      id: 'admin/promotions.form.review.scheduling.date-range',
    },
    timeRange: {
      id: 'admin/promotions.form.review.scheduling.time-range',
    },
    weekdays: {
      monday: {
        id: 'admin/promotions.form.recurrence.weekdays.monday',
      },
      tuesday: {
        id: 'admin/promotions.form.recurrence.weekdays.tuesday',
      },
      wednesday: {
        id: 'admin/promotions.form.recurrence.weekdays.wednesday',
      },
      thursday: {
        id: 'admin/promotions.form.recurrence.weekdays.thursday',
      },
      friday: {
        id: 'admin/promotions.form.recurrence.weekdays.friday',
      },
      saturday: {
        id: 'admin/promotions.form.recurrence.weekdays.saturday',
      },
      sunday: {
        id: 'admin/promotions.form.recurrence.weekdays.sunday',
      },
    },
    description: {
      id: 'admin/promotions.form.review.scheduling-description',
    },
  },
  salesChannels: {
    title: {
      id: 'admin/promotions.form.review.sales-channels',
    },
    empty: { id: 'admin/promotions.form.review.sales-channels.all' },
  },
  sellers: {
    title: {
      id: 'admin/promotions.form.review.sellers',
    },
    empty: { id: 'admin/promotions.form.review.sellers.all' },
    emptyOptIn: {
      id: 'admin/promotions.form.review.sellers.opt-in.description',
    },
    ellipsisTooltip: {
      id: 'admin/promotions.form.review.sellers.opt-in.tooltip',
    },
  },
  discount: {
    title: {
      id: 'admin/promotions.form.review.discount',
    },
    list: {
      id: 'admin/promotions.form.review.discount-on-list',
    },
  },
  restrictions: {
    maxUsage: {
      id: 'admin/promotions.form.review.restrictions.max-usage',
    },
    maxUsagePerClient: {
      id: 'admin/promotions.form.review.restrictions.max-usage-per-client',
    },
    maxItemsPerCart: {
      id: 'admin/promotions.form.review.restrictions.max-items-per-cart',
    },
    maxItemsPerAttribute: {
      id: 'admin/promotions.form.review.restrictions.max-items-per-attribute',
    },
    empty: {
      id: 'admin/promotions.form.review.restrictions.empty',
    },
  },
  accumulate: {
    title: {
      id: 'admin/promotions.form.review.accumulate',
    },
    otherPromotions: {
      id: 'admin/promotions.form.review.accumulate-other-promotions',
    },
    manualPrice: {
      id: 'admin/promotions.form.review.accumulate-manual-pricing',
    },
  },
  buyAndWin: {
    benefit: {
      freeShipping: {
        id: 'admin/promotions.form.review.discount-type.shipping.free-shipping',
      },
      maxPricePerItem: {
        id: 'admin/promotions.form.review.buy-and-win.benefit.max-price-per-item',
      },
      gift: { id: 'admin/promotions.form.review.buy-and-win.benefit.gift' },
      giftMaxQuantity: {
        id: 'admin/promotions.form.review.buy-and-win.benefit.gift.max-quantity',
      },
    },
  },
  moreForLess: {
    percentual: {
      id: 'admin/promotions.form.review.more-for-less.benefit.discount.percentual',
    },
    maxPrice: {
      id: 'admin/promotions.form.review.more-for-less.benefit.discount.maxPrice',
    },
    advanced: {
      title: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.title',
      },
      itemsDetails: {
        id: 'admin/promotions.form.review.more-for-less.benefit.items-details',
      },
      discountDetails: {
        id: 'admin/promotions.form.review.more-for-less.benefit.discount-details',
      },
      equals: {
        id: 'admin/promotions.form.review.more-for-less.benefit.items-details.equals',
      },
      mostExpensive: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.most-expensive',
      },
    },
  },
  progressive: {
    description: {
      id: 'admin/promotions.form.review.progressive-discount.benefit.description',
    },
    itemValue: {
      id: 'admin/promotions.form.review.progressive-discount.benefit.item-value',
    },
    sameItemsOnly: {
      id: 'admin/promotions.form.review.progressive-discount.same-items-only',
    },
  },
  budget: {
    title: { id: 'admin/promotions.form.budget.title' },
    unlimited: { id: 'admin/promotions.form.budget.view.unlimited' },
  },
  audiences: {
    title: { id: 'admin/promotions.form.review.campaign.audiences' },
    item: { id: 'admin/promotions.form.utils.item-label' },
  },
}
